var _defs, _g, _g2, _path, _path2, _g3, _rect, _rect2, _rect3, _polygon, _path3, _path4, _path5, _path6, _g4, _rect4, _rect5, _rect6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavourites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #f2f2f2;\n      }\n\n      .cls-3 {\n        fill: #eaeaea;\n      }\n\n      .cls-4 {\n        fill: #848484;\n      }\n\n      .cls-5 {\n        fill: #333;\n      }\n\n      .cls-6 {\n        fill: #aaa;\n      }\n\n      .cls-7 {\n        fill: #d3d3d3;\n      }\n\n      .cls-8 {\n        fill: #e0e0e0;\n      }\n\n      .cls-9 {\n        fill: #595959;\n      }\n\n      .cls-10 {\n        filter: url(#drop-shadow-1);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -385.48,
    y1: 130.41,
    x2: -385.48,
    y2: 191.14,
    gradientTransform: "translate(-265.69 311.88) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 120,
    cy: 120.05,
    r: 117.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M0,120.05C0,53.88,53.83,.05,120,.05c66.17,0,120,53.83,120,120,0,66.17-53.83,120-120,120C53.83,240.05,0,186.22,0,120.05Zm4.88,0c0,63.48,51.64,115.12,115.12,115.12,63.48,0,115.12-51.64,115.12-115.12,0-63.48-51.65-115.12-115.12-115.12S4.88,56.58,4.88,120.05Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.31,120H13.26V59.61l197.48-.97c8.84,0,16,7.16,16,16l-.43,45.36Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.69,80.41c.49-.99,1.28-.99,1.77,0l3.07,6.22c.49,.99,1.78,1.92,2.86,2.08l6.86,1c1.09,.16,1.33,.92,.55,1.68l-4.97,4.84c-.79,.77-1.28,2.28-1.09,3.37l1.17,6.84c.19,1.08-.46,1.55-1.43,1.04l-6.14-3.23c-.97-.51-2.57-.51-3.54,0l-6.14,3.23c-.97,.51-1.62,.04-1.43-1.04l1.17-6.84c.19-1.08-.31-2.6-1.09-3.37l-4.97-4.84c-.79-.77-.54-1.53,.55-1.68l6.86-1c1.09-.16,2.38-1.09,2.86-2.08l3.07-6.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M159.74,112.02h-62.54c-1.65,0-3-1.35-3-3v-31.02c0-1.65,1.35-3,3-3h62.54c1.65,0,3,1.35,3,3v31.02c0,1.65-1.35,3-3,3Zm-62.54-35.02c-.55,0-1,.45-1,1v31.02c0,.55,.45,1,1,1h62.54c.55,0,1-.45,1-1v-31.02c0-.55-.45-1-1-1h-62.54Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.97,
    y: 83.27,
    width: 12.82,
    height: 12.82,
    rx: 1,
    ry: 1,
    transform: "translate(382.76 179.36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.79,96.59h-10.82c-.83,0-1.5-.67-1.5-1.5v-10.82c0-.83,.67-1.5,1.5-1.5h10.82c.83,0,1.5,.67,1.5,1.5v10.82c0,.83-.67,1.5-1.5,1.5Zm-10.82-12.82c-.28,0-.5,.22-.5,.5v10.82c0,.28,.22,.5,.5,.5h10.82c.28,0,.5-.22,.5-.5v-10.82c0-.28-.22-.5-.5-.5h-10.82Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 193.58,
    y: 90.68,
    width: 1.62,
    height: 3.14,
    transform: "translate(388.79 184.5) rotate(-180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 190.47,
    y: 89.1,
    width: 1.62,
    height: 4.72,
    transform: "translate(382.57 182.92) rotate(-180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 187.36,
    y: 87.55,
    width: 1.62,
    height: 6.27,
    transform: "translate(376.34 181.37) rotate(-180)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.26 181.36 225.74 181.36 226.31 120 13.26 120 13.26 181.36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.5,112.02h-31.02c-1.65,0-3-1.35-3-3v-31.02c0-1.65,1.35-3,3-3h31.02c1.65,0,3,1.35,3,3v31.02c0,1.65-1.35,3-3,3Zm-31.02-35.02c-.55,0-1,.45-1,1v31.02c0,.55,.45,1,1,1h31.02c.55,0,1-.45,1-1v-31.02c0-.55-.45-1-1-1h-31.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.26,99.45c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71l6.45-6.45c.15-.15,.37-.19,.56-.1l6.83,3.11,4.62-3.07c.23-.15,.54-.09,.69,.14,.15,.23,.09,.54-.14,.69l-4.85,3.23c-.14,.1-.33,.11-.48,.04l-6.77-3.08-6.21,6.21c-.1,.1-.23,.15-.35,.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M116.8,97s-.05,0-.07,0l-7.55-1.07c-.27-.04-.46-.29-.42-.57,.04-.27,.29-.47,.57-.42l7.3,1.04,5.08-5.08s.1-.08,.16-.11l5.58-2.42c.25-.11,.55,0,.66,.26,.11,.25,0,.55-.26,.66l-5.49,2.38-5.19,5.19c-.09,.09-.22,.15-.35,.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.02,97c-.16,0-.31-.08-.41-.21l-4.54-6.38,.81-.58,4.12,5.79,3.93-5.79,.83,.56-4.34,6.38c-.09,.14-.24,.22-.41,.22h0Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 178.56,
    y: 89.09,
    width: 12.82,
    height: 12.82,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.38,102.41h-10.82c-.83,0-1.5-.67-1.5-1.5v-10.82c0-.83,.67-1.5,1.5-1.5h10.82c.83,0,1.5,.67,1.5,1.5v10.82c0,.83-.67,1.5-1.5,1.5Zm-10.82-12.82c-.28,0-.5,.22-.5,.5v10.82c0,.28,.22,.5,.5,.5h10.82c.28,0,.5-.22,.5-.5v-10.82c0-.28-.22-.5-.5-.5h-10.82Z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 181.15,
    y: 96.5,
    width: 1.62,
    height: 3.14
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 184.26,
    y: 94.92,
    width: 1.62,
    height: 4.72
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 187.37,
    y: 93.37,
    width: 1.62,
    height: 6.27
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.81,139.55l5.45-7.65h10.9l-16.35-12.85v20.5Zm13,13.15l-7.4-15.85-8.6,12.05v-36l28,22h-14.75l7.25,15.7-4.5,2.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225.74,180.02V74.61c0-8.27-6.92-15-15.43-15H13.26l197.05-.97h0c9.05,0,16.42,7.16,16.42,15.96h0l-1,105.42Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.9a908740.svg";
export { ForwardRef as ReactComponent };